import React, { Component, useEffect, useState } from 'react';
import CountUp from 'react-countup';
import { connect } from 'react-redux';
import axios from 'axios';
import { Redirect } from 'react-router-dom';
import { useHistory } from "react-router-dom";
import jsPDF from "jspdf";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { API_BASE_URL } from '../../../config.js'
import { APP_BASE_URL } from '../../../config.js'
import DataTable, { defaultThemes } from 'react-data-table-component';


import { Accordion } from 'react-bootstrap-accordion'
import 'react-bootstrap-accordion/dist/index.css'

import RecruitmentDetails from '../Employee/RecruitmentDetails.js';

import EmpVerification from '../Employee/EmployeeVerificationControl.js';
import TraingingAccomodation from '../Employee/TrainingAndAccomodation.js';
import '../../../../src/AccordionScroll.css';






import {
	statisticsAction,
	statisticsCloseAction
} from '../../../actions/settingsAction';
import { Link, useLocation } from 'react-router-dom/cjs/react-router-dom.min.js';
import { useParams } from "react-router-dom";
import { useFormStatus } from 'react-dom';
const EmployeeDetailControl = (props) => {
	const sparkline1 = React.createRef();
	const sparkline2 = React.createRef();
	const sparkline3 = React.createRef();
	const sparkline4 = React.createRef();


	const handleStatistics = (e) => {
		statisticsAction(e)
	}
	const closeStatistics = (e) => {
		statisticsCloseAction(e)
	}

	const { fixNavbar, statisticsOpen, statisticsClose } = props;

	const [offerLetterData, setOfferLetterData] = useState(null);
const fetchOfferLetterData = async () => {
  try {
    const res = await axios.get(
      `${API_BASE_URL}/offer-letter/${users.user_id}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      }
    );

    if (res.data.status === 200) {
      setOfferLetterData(res.data.data); // ✅ store data
    } else {
      toast.error("Offer letter data not found");
    }
  } catch (error) {
    toast.error("Failed to load offer letter data");
  }
};



const numberToWords = (num) => {
  if (!num) return "";

  const a = [
    "", "One", "Two", "Three", "Four", "Five", "Six",
    "Seven", "Eight", "Nine", "Ten", "Eleven", "Twelve",
    "Thirteen", "Fourteen", "Fifteen", "Sixteen",
    "Seventeen", "Eighteen", "Nineteen"
  ];

  const b = [
    "", "", "Twenty", "Thirty", "Forty",
    "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"
  ];

  const inWords = (n) => {
    if (n < 20) return a[n];
    if (n < 100) return b[Math.floor(n / 10)] + (n % 10 ? " " + a[n % 10] : "");
    if (n < 1000)
      return a[Math.floor(n / 100)] + " Hundred" + (n % 100 ? " " + inWords(n % 100) : "");
    if (n < 100000)
      return inWords(Math.floor(n / 1000)) + " Thousand" + (n % 1000 ? " " + inWords(n % 1000) : "");
    if (n < 10000000)
      return inWords(Math.floor(n / 100000)) + " Lakh" + (n % 100000 ? " " + inWords(n % 100000) : "");
    return "";
  };

  return inWords(Number(num));
};


const getTitle = (gender, maritalStatus) => {
  if (!gender) return "";

  if (gender === "Male") {
    return "Mr.";
  }

  if (gender === "Female") {
    if (maritalStatus && maritalStatus.toLowerCase() === "single") {
      return "Ms.";
    }
    return "Mrs.";
  }

  return "";
};


const generateOfferLetter = () => {
  const doc = new jsPDF("p", "mm", "a4");
 
  let y = 40; // ✅ TOP MARGIN ADDED

  const designationName =
    designationDropdownOptions.find(d => d.designation_id == designation)
      ?.designation_name || "";

  // ===== DATE (Right aligned) =====
  doc.setFont("times", "normal");
  doc.setFontSize(12);
  doc.text(`Date: ${new Date().toLocaleDateString("en-GB")}`, 190, y, {
    align: "right",
  });

  y += 15;
  const title = getTitle(users.gender, users.marital_status);

  // ===== SALUTATION =====
  doc.setFont("times", "bold");
 doc.text(
    `Dear ${title} ${users.first_name} ${users.last_name},`,
    20,
    y
  );
  y += 15;

  // ===== OFFER HEADING =====
  doc.text("Offer for Employment", 105, y, { align: "center" });

  y += 12;
  doc.setFont("times", "normal");

  // ===== CONTENT =====
  doc.text("Greeting from Annai Arul Hospital,", 20, y);

  y += 10;

  doc.text(
    `We are pleased to offer you employment in our organization as ${designationName} on the following terms and conditions. You will be under probation for 6months.`,
    20,
    y,
    { maxWidth: 170 }
  );

  y += 15;

   const amountInWords = numberToWords(net_take);

  doc.text(
    `Your Net Take Home will be Rs. ${net_take} /- (Rupees ${amountInWords} only) per month.`,
    20,
    y,
    { maxWidth: 170 }
  );
  y += 22;

  // ===== CONDITIONS =====
  doc.text("Your employment is subject to:", 20, y);

  y += 8;
  doc.text("a. Proof of your educational certificates.", 25, y);

  y += 8;
  doc.text("b. Proof of your address.", 25, y);

  y += 8;
  doc.text(
    "c. You have to fill Joining from, Applicant Profile from, PF- Nomination form etc... Arrange to submit it on or before your joining.",
    25,
    y,
    { maxWidth: 165 }
  );

  y += 20;

  // ===== NOTE =====
  doc.text(
    "Please note that this is only a provisional offer for employment and is not to be constructed as an appointment letter.",
    20,
    y,
    { maxWidth: 170 }
  );

  y += 15;

  doc.text(
    "The representations contained in this offer letter and enclosures surpass all prior written or oral presentations or communications pertaining to Annai Arul Hospital offer of Employment.",
    20,
    y,
    { maxWidth: 170 }
  );

  y += 20;

  doc.text(
    "Kindly sign the duplicate copy of this letter as token of your acceptance of the provisional offer. A detailed appointment letter would be sent to you once you fulfill our employment conditions.",
    20,
    y,
    { maxWidth: 170 }
  );

  y += 12;

  // ===== CLOSING =====
  doc.setFont("times", "bold");
  doc.text("Wishing you the very best!", 20, y);

  y += 13;

  doc.text("Very Truly Yours,", 20, y);

  y += 13;

  doc.text("For Annai Arul Hospital Pvt Ltd.", 20, y);

  y += 20; // ✅ BOTTOM SPACE

  // ===== FOOTER =====
  doc.text("Human Resource", 20, y);
  doc.text("Acceptance Signature and Date", 130, y);

  y += 10;

  doc.setFont("times", "normal");
  doc.text("Manager - Human Resources", 20, y);

  // ===== SAVE =====
  doc.save(`Offer_Letter_${users.employee_id}.pdf`);
};


const generateExperienceCertificate = () => {
  const doc = new jsPDF("p", "mm", "a4");

  // Margins
  let y = 25;

  // ===== Helpers =====
  const formatDate = (date) =>
    new Date(date).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });

  const title = getTitle(users.gender, users.marital_status);

  const designationName =
    designationDropdownOptions.find(
      (d) => d.designation_id == designation
    )?.designation_name || "";

  // ===== DATE (Right aligned) =====
  doc.setFont("times", "bold");
  doc.setFontSize(12);
  doc.text(formatDate(users.date_of_leaving || new Date()), 190, y, {
    align: "right",
  });

  y += 25;

  // ===== HEADING =====
  doc.setFont("times", "bold");
  doc.setFontSize(14);
  doc.text("EXPERIENCE CERTIFICATE", 105, y, { align: "center" });

  y += 12;

  // ===== SUB HEADING =====
  doc.setFontSize(11);
  doc.setFont("times", "bold");
  doc.text("To Whomsoever It May Concern", 105, y, { align: "center" });

  // underline
  doc.line(65, y + 1, 145, y + 1);

  y += 20;

  // ===== BODY =====
  doc.setFont("times", "normal");

  doc.text(
    `This is to certify that ${title} ${users.first_name} ${users.last_name} was employed with our organization Annai Arul Hospital from ${formatDate(
      users.date_of_joining
    )} till ${formatDate(
      users.date_of_leaving || new Date()
    )} as ${designationName} in Out Patient department.`,
    25,
    y,
    { maxWidth: 160 }
  );

  y += 20;

  doc.text(
    `In our opinion, ${
      title === "Mr." ? "he" : "she"
    } was such a motivated, duty bound and highly committed team member that ${
      title === "Mr." ? "his" : "her"
    } knowledge was quite a valuable asset to our organization.`,
    25,
    y,
    { maxWidth: 160 }
  );

  y += 20;

  doc.text(
    "We at Annai Arul Hospital wish her all success in her future endeavors.",
    25,
    y,
    { maxWidth: 160 }
  );

  y += 30;

  // ===== SIGNATURE =====
  doc.text("For Annai Arul Hospital,", 25, y);

  y += 15;
  doc.text("Regards,", 25, y);

  y += 25;

  doc.setFont("times", "bold");
  doc.text("Jebin Samuel J", 25, y);

  y += 7;
  doc.setFont("times", "normal");
  doc.text("Manager - Human Resources", 25, y);

  // ===== SAVE =====
  doc.save(`Experience_Certificate_${users.employee_id}.pdf`);
};



		const [salaryUpdateStatus, setSalaryUpdateStatus] = useState("");
		const [users, setUsers] = useState({
			first_name: "",
			last_name: "",
			blood_group: "",
			username:"",
			email:"",
			gender: "",
			date_of_joining: "",
			date_of_leaving: "",
			reason_status: "",
			inactive_reason:"",
			floor_id:"",
			pan_no:"",
			adhar_no:"",
			uan_no:"",
			marital_status:"",
			role:"",
			date_of_birth:"",
			password:"",
			confirm_password:"",
			contact_no:"",
			employee_type:"",
			address:"",
			employee_shift:"",
			contractor:"",
			contractor_type:"",
			pre_pfno:"",
			esi_no:"",
			qualification:"",
			is_active:"",
			experience:"",
			notice_period:"",
			tds_applicable:"",
			pf_status:"",
			notice_period_status:"",
			flat_status:"",
			// current_salary:"",
			// expected_salary:"",
			user_role_id:"",
	
		})


		const handelInput = (event) => {
			event.preventDefault();
			const { name, value } = event.target;
			console.log(name, value)
			setUsers({ ...users, [name]: value });
		}


		const [floorval, setfloorval]= useState([]);
		const [dataval, setdataval]= useState([]);
		const [roleval, setroleval]= useState([]);
		const [current_salary, setCurrentSalary] = useState("");
		const [expected_salary, setExpectedSalary] = useState("");
		const [adhar_no, setAdharNo] = useState("");
		



		const handelNumber = (e) => {
			const inputValue = e.target.value;
		
			// Allow only numeric characters
			if (/^\d*$/.test(inputValue)) {
				setCurrentSalary(inputValue);
			}
		  };

		  const handelNumber1 = (e) => {
			const inputValue = e.target.value;
		
			// Allow only numeric characters
			if (/^\d*$/.test(inputValue)) {
				setExpectedSalary(inputValue);
			}
		  };

		  const handelNumber2 = (e) => {
			const inputValue = e.target.value;
		
			// Allow only numeric characters
			if (/^\d*$/.test(inputValue)) {
				setAdharNo(inputValue);
			}
		  };


	const { search } = useLocation();
	const searchparams = new URLSearchParams(search);
	const param = searchparams.get("id");


	useEffect(() => {
		axios.get(API_BASE_URL + '/showempdetail/' + param, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})
		
			// .then(res => console.log(res.data.last_salary_update_status))
			  .then(res =>  {
				// console.log("Salary Status:", res.data.last_salary_update_status);
				setUsers(res.data.emp_detail[0])
				setSalaryUpdateStatus(res.data.last_salary_update_status)
				setDepartmentValue(res.data.emp_detail[0].department_id)
				setCurrentSalary(res.data.emp_detail[0].current_salary)
				setExpectedSalary(res.data.emp_detail[0].expected_salary)
				setAdharNo(res.data.emp_detail[0].adhar_no)
				setDesignationValue(res.data.emp_detail[0].designation_id)
				fetchSecondDropdownOptions(res.data.emp_detail[0].department_id)
				setEmployeeshift(res.data.emp_detail[0].employee_shift)
				setContractorValue(res.data.emp_detail[0].contractor)
				setContractorTypeValue(res.data.emp_detail[0].contractor_type)
				fetchContractorTypeDropdownOptions(res.data.emp_detail[0].contractor)
				fetchProfilePicture(res.data.emp_detail[0].profile_picture)
				// setContractorValue(res.data.emp_detail[0].employee_type_id)
			  			}		)	.catch(err => console.log(err));
			
	}, [])


	const isReadonly = String(salaryUpdateStatus)?.trim().toUpperCase() === "PENDING";

console.log("Salary Status:", salaryUpdateStatus);
console.log("Readonly:", isReadonly);


	const handleFloor = async () => {

		axios.get(API_BASE_URL +'/showfloor/', {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})
		.then(res1 => setfloorval(res1.data))
		.catch(err => console.log(err))
	   };


	   useEffect(() => {
		handleFloor();
	  }, []);

	  const handleRole = async () => {

		axios.get(API_BASE_URL +'/showrole/', {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})
		.then(res1 => setroleval(res1.data))
		.catch(err => console.log(err))
	   };


	   useEffect(() => {
		handleRole();
	  }, []);


	  const handleDepartment = async () => {

		axios.get(API_BASE_URL +'/showdepartment/', {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})
		.then(res1 => setdataval(res1.data))
		.catch(err => console.log(err))
	   };


	   useEffect(() => {
		handleDepartment();
	  }, []);


	   const [department, setDepartmentValue] = useState("");
	   const [designationDropdownOptions,setDesignationDropdownOptions]=useState([]);
	   const [designation,setDesignationValue] = useState("");
	   const [contact_no, setNumValue] = useState("");
	   //const [firstDropdownValue, setFirstDropdownValue] = useState("");
	  //   const [secondDropdownOptions, setSecondDropdownOptions] = useState([]);
	  //   const [secondDropdownValue, setSecondDropdownValue] = useState("");
	  
		// Handle first dropdown change
		const handleFirstDropdownChange = (event) => {
		  const value = event.target.value;
		  setDepartmentValue(value);
	  
		  // Trigger API call based on the selected value
		  fetchSecondDropdownOptions(value);
		};
	  
	  
	  
		 // Fetch options for the second dropdown
		 const fetchSecondDropdownOptions = async (selectedValue) => {
		  try {
		  
		const response = await fetch(
			  API_BASE_URL + '/showdesignationcheck/'+selectedValue, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		}
			); // Replace with your API URL
	  
			const data = await response.json();
			setDesignationDropdownOptions(data); // Assuming the API returns an array of options
		  } catch (error) {
			console.error("Error fetching second dropdown options:", error);
		  }
		};
	  
		  // Handle second dropdown change
		const handleSecondDropdownChange = (event) => {
			// setSecondDropdownValue(event.target.value);
			setDesignationValue(event.target.value);
		  };
	  



	  const [employee_shift,setEmployeeshift]= useState("");
	  const [contractordata,setContractorData]= useState([]);
	  const [contractor,setContractorValue]= useState("");
	  const [contractotypeDropdownOptions,setContractorTypeDropdownOptions]= useState([]);
	  const [contractortype,setContractorTypeValue]= useState("");
	  const [shiftemployee,setShiftEmployee]=useState("");


	  const handleContractor = async () => {

		axios.get(API_BASE_URL +'/showcontractor/', {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})
		.then(res1 => setContractorData(res1.data))
		.catch(err => console.log(err))
	   };


	   useEffect(() => {
		handleContractor();
	  }, []);



	  const handleContractorDropdownChange = (event) => {
		const value = event.target.value;
		setContractorValue(value);
	
		// Trigger API call based on the selected value
		fetchContractorTypeDropdownOptions(value);
	  };
	
	
	
	//    Fetch options for the second dropdown
	   const fetchContractorTypeDropdownOptions = async (selectedValue) => {
		try {
		
		const response = await fetch(
			API_BASE_URL + '/showcontractortype/'+selectedValue,{
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		}
		  ); // Replace with your API URL
	
		  const data = await response.json();
		  setContractorTypeDropdownOptions(data); // Assuming the API returns an array of options
		} catch (error) {
		  console.error("Error fetching second dropdown options:", error);
		}
	  };
	
		// Handle second dropdown change
		const handleContractorTypeDropdownChange = (event) => {
			// setSecondDropdownValue(event.target.value);
			setContractorTypeValue(event.target.value);
		  };


		  const handelShiftEmployee = (event) => {

			setEmployeeshift(event.target.value);
	
			// if (event.target.value === '1') {
			// 	setIsVisible(true);
			// } else {
			// 	setIsVisible(false);
			// }
		}


	const handleEditSubmit = (e) => {

		

		e.preventDefault();
		
		// console.log(user);
		// setError(null);
		// setLoading(true);
		// e.preventDefault();
		// alert('hi');

		    const payload = {
        first_name: users.first_name,
        last_name: users.last_name,
        username: users.username,
        blood_group: users.blood_group,
        email: users.email,
        gender: users.gender,
        floor_id: users.floor_id,
        contact_no: users.contact_no,
        department_id: department,
        designation_id: designation,
        date_of_birth: users.date_of_birth,
        date_of_joining: users.date_of_joining,
        pan_no: users.pan_no,
        adhar_no: adhar_no,
        uan_no: users.uan_no,
        marital_status: users.marital_status,
        pre_pfno: users.pre_pfno,
        esi_no: users.esi_no,
        qualification: users.qualification,
        status: users.is_active,
        experience: users.experience,
        notice_period: users.notice_period,
        tds_applicable: users.tds_applicable,
        pf_status: users.pf_status,
        notice_period_status: users.notice_period_status,
        flat_status: users.flat_status,
        current_salary: current_salary,
        expected_salary: expected_salary,
        user_role_id: users.user_role_id,
        employee_shift: employee_shift,
        contractor: contractor,
        contractor_type: contractortype,
        id: users.user_id,
    };

    // ✅ If employee inactive (resigned) add leaving details
    if (users.is_active == 0) {
        payload.date_of_leaving = users.date_of_leaving;
        payload.inactive_reason = users.inactive_reason;
		payload.reason_status = users.reason_status;
    }


// console.log(payload);
		// ,pre_pfno:users.pre_pfno,esi_no:users.esi_no,qualification:users.qualification,status:users.is_active,experience:users.experience,notice_period:users.notice_period,
		axios.post(API_BASE_URL + '/updateempdetail', payload, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		}).then(response => {
			// console.log(response);
			// // 	console.log(response.data.message);
			//  })
console.log(response.data);
			var status = response.data.status;

			if (status == 200) {
				toast.success(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});

				// const timeout = setTimeout(() => {
				// 	window.location.reload(); // Reload the current page
				// }, 5000); // Refresh after 5 seconds

				// return () => {
				// 	clearTimeout(timeout); // Cleanup the timeout if the component unmounts
				// };

			} else if (status == 401) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}
			else if (status == 400) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}


		}).catch(error => {
			// console.log(error);
			// console.log(error.response.data.message);




			toast.error(error.response.data.message, {
				position: "bottom-right",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "colored",


			});

		});
	};


	const [allemployeeval, setallemployeeval]= useState([]);
	const [inchargeval,setInchargeValue]= useState("");
	const [hodval,setHodValue]= useState("");


	const handleAllEmployee = async () => {

		axios.get(API_BASE_URL +'/showallemployee/', {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})
		// .then(res1 => console.log(res1.data.user_det))
		.then(res1 => setallemployeeval(res1.data.user_det))
		.catch(err => console.log(err))
	   };


	   useEffect(() => {
		handleAllEmployee();
	  }, []);


	  useEffect(() => {
		axios.get(API_BASE_URL + '/approvalinformation/' + param, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})
			// .then(res => console.log(res.data.emp_detail[0].first_name))
			  .then(res =>  {
				setInchargeValue(res.data.incharge_id)
				setHodValue(res.data.hod_id)
				
				// setContractorValue(res.data.emp_detail[0].employee_type_id)
			  			}		)	.catch(err => console.log(err));
			
	}, [])


	const handleapprovalinchargeChange = (event) => {
		const value = event.target.value;
		//  console.log(value);
		setInchargeValue(value);
	
	  };


	  const handleapprovalhodChange = (event1) => {
		const value1 = event1.target.value;
		// console.log(value1);
		setHodValue(value1);
	
	  };


	  const handleApprovalSubmit = (e) => {

		

		e.preventDefault();

		//  alert(inchargeval);
		// alert(hodval);
		
		// console.log(user);
		// setError(null);
		// setLoading(true);
		// e.preventDefault();

		// ,pre_pfno:users.pre_pfno,esi_no:users.esi_no,qualification:users.qualification,status:users.is_active,experience:users.experience,notice_period:users.notice_period,
		axios.post(API_BASE_URL + '/updateempapproval', { incharge_id: inchargeval,hod_id:hodval,id:param}, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		}).then(response => {
			// console.log(response);
			// // 	console.log(response.data.message);
			//  })

			console.log(response.data);
			var status = response.data.status;

			if (status == 200) {
				toast.success(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});

				// const timeout = setTimeout(() => {
				// 	window.location.reload(); // Reload the current page
				// }, 5000); // Refresh after 5 seconds

				// return () => {
				// 	clearTimeout(timeout); // Cleanup the timeout if the component unmounts
				// };

			} else if (status == 401) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}
			else if (status == 400) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}


		}).catch(error => {
			// console.log(error);
			// console.log(error.response.data.message);




			toast.error(error.response.data.message, {
				position: "bottom-right",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "colored",


			});

		});
	};





    
	const [gross_salary, setGross] = useState("");
	const [convy, setConvy] = useState("0");
	const[wash_allow,setWashAllow]=useState("0");
	const [basic_salary, setBasicSalary] = useState("");
	const [hra, setHra] = useState("");
	const [special_convyance, setSpecialConvyance] = useState("");
	const [pf_employer, setPfEmployer] = useState("");
	const [esi_employer, setEsiEmployer] = useState("");
	const [pf_employee, setPfEmployee] = useState("");
	const [esi_employee, setEsiEmployee] = useState("");
	const [insurance, setInsurance] = useState("0");
	const [pt, setPt] = useState("");
	const [hostel_fee, setHostelFee] = useState("0");
	const [tds, setTds] = useState("");
	const [ctc, setCtc] = useState("");
	const [net_take, setNettake] = useState("");
	const [uan_no, setUanNo] = useState("");
	const [account_no, setAccountNo] = useState("");
	const [pf_no, setPfNo] = useState("");
	const [esi_no, setEsiNo] = useState("");

	const handelsalaryInput = (gross,con,wash,insur,hostfee) => {


		


		axios.post(API_BASE_URL + '/showsalaryfitment', { gross_salary: gross,convy:con,wash_allow:wash,insurance:insur,hostel_fee:hostfee}, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		}).then(res1 =>  {
			setBasicSalary(res1.data.basic_salary)
			setHra(res1.data.hra)
			setPfEmployer(res1.data.pf_employer)
			setPfEmployee(res1.data.pf_employee)
			setEsiEmployer(res1.data.esi_employer)
			setEsiEmployee(res1.data.esi_employee)
			setPt(res1.data.pt)
			setCtc(res1.data.ctc)
			setNettake(res1.data.net_take)
		}

		 )
			.catch(err => console.log(err));
	};


	const handleSalarySubmit = async (e) => {

		e.preventDefault();
	   
	
		// setError(null);
		// setLoading(true);
		// e.preventDefault();
		axios.post(API_BASE_URL+'/addsalaryinfo', { gross_salary: gross_salary, convy: convy,wash_allow: wash_allow,basic_salary: basic_salary, hra: hra,special_convyance: special_convyance,pf_employer: pf_employer,esi_employer: esi_employer,pf_employee: pf_employee,esi_employee: esi_employee,insurance: insurance,hostel_fee: hostel_fee,pt: pt, ctc: ctc, net_take: net_take,uan_no:uan_no,account_no:account_no,pf_no:pf_no,esi_no:esi_no,user_id:param}, {
						headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
					}).then(response => {
			// 	console.log(response.data);
			// 	console.log(response.data.message);
			// })
	
			var status = response.data.status;
	
			if (status == 200) {
				toast.success(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",
	
				});
	
	
				// const timeout = setTimeout(() => {
				// 	window.location.reload(); // Reload the current page
				// }, 5000); // Refresh after 5 seconds
	
				// return () => {
				// 	clearTimeout(timeout); // Cleanup the timeout if the component unmounts
				// };
	
			} else if(status == 401) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",
	
				});
			}
			else if (status == 400) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",
	
				});
			}
	
	
		}).catch(error => {
			// console.log(error);
			// console.log(error.response.data.message);
	
	
	
	
			toast.error(error.response.data.message, {
				position: "bottom-right",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "colored",
	
	
			});
	
		});
	};


	useEffect(() => {
		axios.get(API_BASE_URL + '/displaysalarydetail/' + param, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})
			// .then(res => console.log(res.data.emp_detail[0].first_name))
			  .then(res =>  {
				setGross(res.data.gross_salary)
				setConvy(res.data.convy)
				setWashAllow(res.data.wash_allow)
				setBasicSalary(res.data.basic_salary)
			setHra(res.data.hra)
			setSpecialConvyance(res.data.special_convyance)
			setPfEmployer(res.data.pf_employer)
			setPfEmployee(res.data.pf_employee)
			setEsiEmployer(res.data.esi_employer)
			setEsiEmployee(res.data.esi_employee)
			setPt(res.data.pt)
			setInsurance(res.data.insurance)
			setHostelFee(res.data.hostel_fee)
			setCtc(res.data.ctc)
			setNettake(res.data.net_take)
			setUanNo(res.data.uan_no)
			setAccountNo(res.data.account_no)
			setPfNo(res.data.pf_no)
			setEsiNo(res.data.esi_no)
				
				// setContractorValue(res.data.emp_detail[0].employee_type_id)
			  			}		)	.catch(err => console.log(err));
			
	}, [])

	

	const [newpassword,setNewPassword]= useState("");
	const [confirmnewpassword,setConfirmNewPassword]= useState("");


	const handleNewPasswordChange = (event) => {
		const value = event.target.value;
		setNewPassword(value);
	
	  };


	  const handleConfirmNewPasswordChange = (event) => {
		const value = event.target.value;
		setConfirmNewPassword(value);
	
	  };

	const handleChangePaswordSubmit = (e) => {

		

		e.preventDefault();
		
		// console.log(user);
		// setError(null);
		// setLoading(true);
		// e.preventDefault();

		// ,pre_pfno:users.pre_pfno,esi_no:users.esi_no,qualification:users.qualification,status:users.is_active,experience:users.experience,notice_period:users.notice_period,
		axios.post(API_BASE_URL + '/changepassword', { password: newpassword,confirm_password:confirmnewpassword,id:param}, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		}).then(response => {
			// console.log(response);
			// // 	console.log(response.data.message);
			//  })

			var status = response.data.status;

			if (status == 200) {
				toast.success(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});

				// const timeout = setTimeout(() => {
				// 	window.location.reload(); // Reload the current page
				// }, 5000); // Refresh after 5 seconds

				// return () => {
				// 	clearTimeout(timeout); // Cleanup the timeout if the component unmounts
				// };

			} else if (status == 401) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}
			else if (status == 400) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}


		}).catch(error => {
			// console.log(error);
			// console.log(error.response.data.message);




			toast.error(error.response.data.message, {
				position: "bottom-right",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "colored",


			});

		});
	};


	const [image, setImage] = useState(null);
	const [preview, setPreview] = useState(null);
	const [uploading, setUploading] = useState(false);
	const [fetchprofile,fetchProfilePicture]= useState("");

	const imagepath=APP_BASE_URL+'/aah-api/uploads/profile/'+fetchprofile;


	const handleImageChange = (event) => {
		const file = event.target.files[0];
		if (file) {
		  setImage(file);
		//   setPreview(URL.createObjectURL(file)); // Preview image
		}
	  };


	  const handleProfileSubmit = (e) => {

		

		e.preventDefault();
		
		// console.log(user);
		// setError(null);
		// setLoading(true);
		// e.preventDefault();

		// ,pre_pfno:users.pre_pfno,esi_no:users.esi_no,qualification:users.qualification,status:users.is_active,experience:users.experience,notice_period:users.notice_period,
		axios.post(API_BASE_URL + '/profilepicture', { image: image,id:param}, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}`,'Content-Type': 'multipart/form-data' },
		}).then(response => {
			// console.log(response);
			// // 	console.log(response.data.message);
			//  })

			var status = response.data.status;

			if (status == 200) {
				toast.success(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});

				// const timeout = setTimeout(() => {
				// 	window.location.reload(); // Reload the current page
				// }, 5000); // Refresh after 5 seconds

				// return () => {
				// 	clearTimeout(timeout); // Cleanup the timeout if the component unmounts
				// };

			} else if (status == 401) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}
			else if (status == 400) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}


		}).catch(error => {
			// console.log(error);
			// console.log(error.response.data.message);




			toast.error(error.response.data.message, {
				position: "bottom-right",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "colored",


			});

		});
	};

	const [edu, setEdu] = useState({
		qualification_name: "",
		educationlevel: "",
		from_year: "",
		to_year:"",
		language:"",
		skill: "",
		description: "",
	})


	const handelEducationInput = (event1) => {
		event1.preventDefault();
		const { name1, value1 } = event1.target;
		console.log(event1.target.value)
		setEdu({ ...edu, [event1.target.name]: event1.target.value });
	}



	const [alleducationlevel,setalleducationlevel]=useState([]);
	const [allqualificationlanguage,setallqualificationlanguage]=useState([]);
	const [allqualificationskill,setallqualificationskill]=useState([]);



	const handleAllEducationLevel = async () => {

		axios.get(API_BASE_URL +'/alleducationlevel/', {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})
		//  .then(res1 => console.log(res1.data))
		.then(res1 => setalleducationlevel(res1.data))
		.catch(err => console.log(err))
	   };


	   useEffect(() => {
		handleAllEducationLevel();
	  }, []);



	  const handleAllQualificationLanguage = async () => {

		axios.get(API_BASE_URL +'/allqualificationlanguage/', {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})
		//   .then(res1 => console.log(res1.data))
		 .then(res1 => setallqualificationlanguage(res1.data))
		.catch(err => console.log(err))
	   };


	   useEffect(() => {
		handleAllQualificationLanguage();
	  }, []);


	  const handleAllQualificationSkill = async () => {

		axios.get(API_BASE_URL +'/allqualificationskill/', {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})
		//   .then(res1 => console.log(res1.data))
		 .then(res1 => setallqualificationskill(res1.data))
		.catch(err => console.log(err))
	   };


	   useEffect(() => {
		handleAllQualificationLanguage();
	  }, []);



	  const handleQualifcationSubmit = (e) => {

		

		e.preventDefault();
		
		// console.log(user);
		// setError(null);
		// setLoading(true);
		// e.preventDefault();

		// alert(edu.educationlevel);

		// ,pre_pfno:users.pre_pfno,esi_no:users.esi_no,qualification:users.qualification,status:users.is_active,experience:users.experience,notice_period:users.notice_period,
		axios.post(API_BASE_URL + '/addqualification', { qualification_name: edu.qualification_name,education_level:edu.educationlevel,from_year:edu.from_year,to_year:edu.to_year,language:edu.language,skill:edu.skill,description:edu.description,user_id:param}, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		}).then(response => {
			// console.log(response);
			// // 	console.log(response.data.message);
			//  })

			var status = response.data.status;

			if (status == 200) {
				toast.success(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});

				// const timeout = setTimeout(() => {
				// 	window.location.reload(); // Reload the current page
				// }, 5000); // Refresh after 5 seconds

				// return () => {
				// 	clearTimeout(timeout); // Cleanup the timeout if the component unmounts
				// };

			} else if (status == 401) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}
			else if (status == 400) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}


		}).catch(error => {
			// console.log(error);
			// console.log(error.response.data.message);




			toast.error(error.response.data.message, {
				position: "bottom-right",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "colored",


			});

		});
	};


	const emptyWork={
		company_name: "",
		post: "",
		from_date: "",
		to_date:"",
		description: "",
	}


	const [work, setWork] = useState({
		company_name: "",
		post: "",
		from_date: "",
		to_date:"",
		description: "",
	})


	const handelWorkExpInput = (event2) => {
		event2.preventDefault();
		const { name1, value1 } = event2.target;
		console.log(event2.target.value)
		setWork({ ...work, [event2.target.name]: event2.target.value });
	}



	const handleWorkingExpSubmit = (e) => {

		

		e.preventDefault();
		
		// console.log(user);
		// setError(null);
		// setLoading(true);
		// e.preventDefault();

	//    alert(work.company_name);

		// ,pre_pfno:users.pre_pfno,esi_no:users.esi_no,qualification:users.qualification,status:users.is_active,experience:users.experience,notice_period:users.notice_period,
		axios.post(API_BASE_URL + '/addworkingexperience', { company_name: work.company_name,post:work.post,from_date:work.from_date,to_date:work.to_date,description:work.description,user_id:param}, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		}).then(response => {
			// console.log(response);
			// // 	console.log(response.data.message);
			//  })

			var status = response.data.status;

			if (status == 200) {
				toast.success(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});

				// const timeout = setTimeout(() => {
				// 	window.location.reload(); // Reload the current page
				// }, 5000); // Refresh after 5 seconds

				// return () => {
				// 	clearTimeout(timeout); // Cleanup the timeout if the component unmounts
				// };

			} else if (status == 401) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}
			else if (status == 400) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}


		}).catch(error => {
			// console.log(error);
			// console.log(error.response.data.message);




			toast.error(error.response.data.message, {
				position: "bottom-right",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "colored",


			});

		});
	};



	const [data, setData] = useState([]);
	

	useEffect(() => {
		axios.get(API_BASE_URL + '/fetchworkexperience', {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})


			.then(res => setData(res.data))
			//.then(res => console.log(res.data))
			.catch(err => console.log(err));
	}, [])



	const handleUpdate = async (id) => {

		axios.get(API_BASE_URL + '/showworkexp/' + id, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})
			.then(res1 => setWork(res1.data))
			.catch(err => console.log(err))
	};




	const handleEditWorkExpSubmit = (e) => {

		e.preventDefault();

		// console.log(user);
		// setError(null);
		// setLoading(true);
		// e.preventDefault();
		axios.post(API_BASE_URL + '/updateworkexp', { company_name: work.company_name, post: work.post, from_date: work.from_date,to_date:work.to_date,description:work.description,id: work.work_experience_id }, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		}).then(response => {
			// console.log(response.data);
			// // 	console.log(response.data.message);
			//  })

			var status = response.data.status;

			if (status == 200) {
				toast.success(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});

				const timeout = setTimeout(() => {
					window.location.reload(); // Reload the current page
				}, 5000); // Refresh after 5 seconds

				return () => {
					clearTimeout(timeout); // Cleanup the timeout if the component unmounts
				};

			} else if (status == 401) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}
			else if (status == 400) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}


		}).catch(error => {
			// console.log(error);
			// console.log(error.response.data.message);




			toast.error(error.response.data.message, {
				position: "bottom-right",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "colored",


			});

		});
	};


	const [alldocumenttypelevel,setalldocumenttypelevel]=useState([]);
	// const [allqualificationlanguage,setallqualificationlanguage]=useState([]);
	// const [allqualificationskill,setallqualificationskill]=useState([]);


	const handleAllDocumentLevel = async () => {

		axios.get(API_BASE_URL +'/alldocumenttype/', {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})
		//   .then(res1 => console.log(res1.data))
		 .then(res1 => setalldocumenttypelevel(res1.data))
		.catch(err => console.log(err))
	   };


	   useEffect(() => {
		handleAllDocumentLevel();
	  }, []);



	  const [document, setDocument] = useState({
		document_type: "",
		date_of_expiry: "",
		document_title: "",
		document_file:"",
		description: "",
	})

	const [docfile,setDocFile]=useState(null);

	const handleDocumentChange = (event) => {
		const file = event.target.files[0];
		if (file) {
			setDocFile(file);
		//   setPreview(URL.createObjectURL(file)); // Preview image
		}
	  };


	const handelDocumentUploadInput = (event2) => {
		event2.preventDefault();
		const { name1, value1 } = event2.target;
		console.log(event2.target.value)
		setDocument({ ...document, [event2.target.name]: event2.target.value });
	}



	const handleDocumentUploadSubmit = (e) => {

		

		e.preventDefault();
		
		// console.log(user);
		// setError(null);
		// setLoading(true);
		// e.preventDefault();

	//    alert(work.company_name);

		// ,pre_pfno:users.pre_pfno,esi_no:users.esi_no,qualification:users.qualification,status:users.is_active,experience:users.experience,notice_period:users.notice_period,
		axios.post(API_BASE_URL + '/adddocument', { document_type: document.document_type,date_of_expiry:document.date_of_expiry,title:document.title,document_file:docfile,description:document.description,user_id:param}, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}`,'Content-Type': 'multipart/form-data' },
		}).then(response => {
			// console.log(response);
			// // 	console.log(response.data.message);
			//  })

			var status = response.data.status;

			if (status == 200) {
				toast.success(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});

				// const timeout = setTimeout(() => {
				// 	window.location.reload(); // Reload the current page
				// }, 5000); // Refresh after 5 seconds

				// return () => {
				// 	clearTimeout(timeout); // Cleanup the timeout if the component unmounts
				// };

			} else if (status == 401) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}
			else if (status == 400) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}


		}).catch(error => {
			// console.log(error);
			// console.log(error.response.data.message);




			toast.error(error.response.data.message, {
				position: "bottom-right",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "colored",


			});

		});
	};



	const [docfetch, setDocFetch] = useState([]);
	

	useEffect(() => {
		axios.get(API_BASE_URL + '/fetchdocument/'+param, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})


			.then(res => setDocFetch(res.data))
			// .then(res => console.log(res.data))
			.catch(err => console.log(err));
	}, [])




	const handleDocUpdate = async (id) => {

		axios.get(API_BASE_URL + '/showdoctype/' + id, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})
			.then(res1 => setDocument(res1.data))
			.catch(err => console.log(err))
	};

    const filepath=APP_BASE_URL+'/uploads/document/'+document.document_file;


	const handleEditDocumentSubmit = (e) => {

		

		e.preventDefault();

		
		// setError(null);
		// setLoading(true);
		// e.preventDefault();
		axios.post(API_BASE_URL + '/updatedocumentdet', { document_type: document.document_type,date_of_expiry:document.date_of_expiry,title:document.title,document_file:docfile,description:document.description,user_id:param,id:document.document_id}, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}`,'Content-Type': 'multipart/form-data' },
		}).then(response => {
			// console.log(response.data);
			// // 	console.log(response.data.message);
			//  })

			var status = response.data.status;

			if (status == 200) {
				toast.success(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});

				const timeout = setTimeout(() => {
					window.location.reload(); // Reload the current page
				}, 5000); // Refresh after 5 seconds

				return () => {
					clearTimeout(timeout); // Cleanup the timeout if the component unmounts
				};

			} else if (status == 401) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}
			else if (status == 400) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}


		}).catch(error => {
			// console.log(error);
			// console.log(error.response.data.message);




			toast.error(error.response.data.message, {
				position: "bottom-right",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "colored",


			});

		});
	};



	
// console.log(console.log(users))

const [toggle,setToggle]=useState(false);


	return (
		<>


			<div>
				<div>
					<div className={`section-body ${fixNavbar ? "marginTop" : ""} `}>
						<div className="container-fluid">

							<ToastContainer />
							<div className="d-flex justify-content-between align-items-center mb-3">
								<div className="header-action"></div>
							</div>

						</div>
					</div>


								


					<div className="section-body mt-3">
						<div className="container-fluid">
							<div className="row clearfix">
								<div className="col-md-12">
									<div className="card">

									<div className="card-header">
											<h3 className="card-title" style={{backgroundColor:"#2760fb",color:"white"}}>{users.first_name}&nbsp;{users.last_name} ({users.employee_id})</h3>
										</div>
										
										<div className="card-body" >

										<Accordion title="Basic Information">
										<div className="accordion-body-scroll">
										<div className="card">
								
							
								<div className="card-header">
									
								{/* <div className="section-body mt-3"> */}
								
													<div className="container-fluid">
														<div className="row clearfix">
															<div className="col-md-12">
																<div className="card">


									 <div className="card-body">
										<form onSubmit={handleEditSubmit}>
{/* {typeof users !== 'undefined' &&
console.log(users)
								(	users.map((item, index) => {
										return ( */}

                                            <div class="row" key={users.user_id}>

										{/* <div class="row"> */}

											<div className="col-md-3 col-sm-12 required-tooltip">
												<div className="form-group">
												<label className="form-label">First Name </label>
													<input
														type="text"
														className="form-control required-input required-tooltip" name="first_name" value={users.first_name} onChange={handelInput}
														placeholder="First Name *"
													/>

													<input name="id" value={users.user_id} type="hidden" />
												</div>
											</div>


											<div className="col-md-3 col-sm-12 required-tooltip">   
												<div className="form-group"> 
												<label className="form-label">Last Name </label>
													<input
														type="text"
														className="form-control required-input required-tooltip"
														placeholder="Last Name" name="last_name" value={users.last_name} onChange={handelInput}
													/>
												</div>
											</div>


											<div className="col-md-3 col-sm-12">   
												<div className="form-group"> 
												<label className="form-label">Blood Group </label>
												{/* <input
														type="text"
														className="form-control"
														placeholder="Last Name" name="blood_group" value={users.blood_group} onChange={handelInput}
													/> */}



													<select className="form-control show-tick" name="blood_group" value={users.blood_group} onChange={handelInput}>
														<option value="">Select Blood Group</option>
														<option value="A+">A+</option>
														<option value="A-">A-</option>
														<option value="B+">B+</option>
														<option value="B-">B-</option>
														<option value="O+">O+</option>
														<option value="O-">O-</option>
														<option value="AB+">AB+</option>
														<option value="AB-">AB-</option>
														
													</select>
												
												</div>
											</div>


											<div className="col-md-3 col-sm-12 ">   
												<div className="form-group"> 
												<label className="form-label">Employee Id</label>
													<input
														type="text"
														className="form-control" disabled
														placeholder="Employee Id" name="employee_id" value={users.employee_id} onChange={handelInput}
													/>
												</div>
											</div>


											<div className="col-md-3 col-sm-12 required-tooltip">   
												<div className="form-group"> 
												<label className="form-label">Username </label>
													<input
														type="text"
														className="form-control required-input required-tooltip"
														placeholder="Username" name="username" value={users.username} onChange={handelInput}
													/>
												</div>
											</div>


											<div className="col-md-3 col-sm-12 required-tooltip">   
												<div className="form-group"> 
												<label className="form-label">Email </label>
													<input
														type="text"
														className="form-control required-input required-tooltip"
														placeholder="Email" name="email" value={users.email} onChange={handelInput}
													/>
												</div>
											</div>

											<div className="col-md-3 col-sm-12 required-tooltip">   
												<div className="form-group"> 
												<label className="form-label">Contact Number </label>
													<input
														type="text"
														className="form-control required-input required-tooltip"
														placeholder="Contact Number" name="contact_no" value={users.contact_no} onChange={handelInput}  maxlength="10" 
													/>
												</div>
											</div>

											<div className="col-md-3 col-sm-12 required-tooltip">
												<div className="form-group">
												<label className="form-label">Gender </label>
													<select className="form-control show-tick required-input required-tooltip" name="gender" value={users.gender} onChange={handelInput}>
														<option value="">Select Gender</option>
														<option value="Male">Male</option>
														<option value="FeMale">Female</option>
														
													</select>
												</div>
											</div>

											<div className="col-md-3 col-sm-12 required-tooltip">
			<div className="form-group">
			<label className="form-label">Floor </label>

			<select className="form-control show-tick required-input required-tooltip" name="floor_id" value={users.floor_id} onChange={handelInput}>
			<option>Select Floor</option>
				{floorval.map(option => (
				<option key={option.floor_id} value={option.floor_id}>
				{option.floor_name}
				</option>
				))}
        </select>
		</div>
       </div>


	   <div className="col-md-3 col-sm-12 required-tooltip">
			<div className="form-group">
			<label className="form-label">Department </label>

			<select className="form-control show-tick required-input required-tooltip" name="department" value={department} onChange={handleFirstDropdownChange}>
			<option>Select Department</option>
				{dataval.map(option => (
				<option key={option.department_id} value={option.department_id}>
				{option.department_name}
				</option>
				))}
        </select>
				{/* <select className="form-control show-tick" name="department" value={user.department} onChange={handleFirstDropdownChange}>
					<option>Select Department</option>

					{dataval.map(option => (
					<option key={option.department_id} value={option.department_id}>
					{option.department_name}
					</option>
					))}
				</select> */}
			</div>
		</div>

		<div className="col-md-3 col-sm-12 required-tooltip">
			<div className="form-group">
			<label className="form-label">Designation </label>
			<select className="form-control show-tick required-input required-tooltip"
          value={designation} name="designation"
          onChange={handleSecondDropdownChange}
          disabled={designationDropdownOptions.length === 0}
        >
          <option value="">Select Designation</option>
          {designationDropdownOptions.map((option) => (
            <option key={option.designation_id} value={option.designation_id}>
              {option.designation_name}
            </option>
          ))}
        </select>
			</div>
		</div>


		<div className="col-md-3 col-sm-12 required-tooltip">
	<label className="form-label">Date Of Joining </label>
		<div className="form-group">

		<input type="date" className="form-control" name="date_of_joining" value={users.date_of_joining}
								onChange={handelInput} placeholder="Select Date of Joining" />
		</div>
	</div>


	<div className="col-md-3 col-sm-12 required-tooltip">
			<label className="form-label">Date Of Birth </label>
			<div className="form-group">

			<input type="date" className="form-control required-input required-tooltip" name="date_of_birth" value={users.date_of_birth}
								onChange={handelInput} placeholder="Select Date of Birth" />
			</div>
	</div>

 

	<div className="col-md-3 col-sm-12">
	<label className="form-label">Pan no </label>
        <div class="form-group">
            <input class="form-control" placeholder="PAN Number" name="pan_no" type="text" value={users.pan_no} onChange={handelInput} />
        </div>
    </div>

	<div className="col-md-3 col-sm-12">
	<label className="form-label">Adhaar No</label>
        <div class="form-group">
            <input class="form-control " placeholder="Adhaar No" name="adhar_no" type="text" value={adhar_no} onChange={handelNumber2}/>
        </div>
    </div>


	<div className="col-md-3 col-sm-12">
	<label className="form-label">UAN No</label>
        <div class="form-group">
            <input class="form-control" placeholder="UAN No" name="uan_no" type="text" value={users.uan_no} onChange={handelInput}/>
        </div>
    </div>

	<div className="col-md-3 col-sm-12">
			<div className="form-group">
			<label className="form-label">Marital Status </label>

			<select className="form-control show-tick" name="marital_status" value={users.marital_status} onChange={handelInput}>
			<option value="">Marital Status</option>
			<option value="Single">Single</option>
                      <option value="Married">Married</option>
                      <option value="Widowed">Widow</option>
                      <option value="Divorced or Separated">Divorced or Separated</option>
        </select>
		</div>
       </div>


   <div className="col-md-3 col-sm-12">
		<label className="form-label">Prev PF No </label>
        <div class="form-group">
            <input class="form-control" placeholder="Previous PF No" name="pre_pfno" type="text" value={users.pre_pfno} onChange={handelInput} />
        </div>
    </div>


	<div className="col-md-3 col-sm-12">
		<label className="form-label">ESI No</label>
        <div class="form-group">
            <input class="form-control" placeholder="ESI No" name="esi_no" type="text" value={users.esi_no} onChange={handelInput} />
        </div>
    </div>


	<div className="col-md-3 col-sm-12">
		<label className="form-label">Qualification</label>
        <div class="form-group">
            <input class="form-control" placeholder="Qualification" name="qualification" type="text" value={users.qualification} onChange={handelInput} />
        </div>
    </div>

	  <div className="col-md-3 col-sm-12">
			<div className="form-group">
			<label className="form-label">Login Status </label>

			<select className="form-control show-tick" name="is_active" value={users.is_active} onChange={handelInput}>
			<option value="0">InActive</option>
			<option value="1">Active</option>
            
        </select>
		</div>
       </div>


	      {Number(users.is_active) === 0 && (
  <>
	<div className="col-md-3 col-sm-12 required-tooltip">
			<label className="form-label">Date Of Leaving </label>
			<div className="form-group">

			<input type="date" className="form-control required-input required-tooltip" name="date_of_leaving" value={users.date_of_leaving}
								onChange={handelInput} placeholder="Select Date of Leaving" />
			</div>
	</div>

	<div className="col-md-3 col-sm-12">
			<div className="form-group">
			<label className="form-label">Reason Status </label>

			<select className="form-control show-tick" name="reason_status" value={users.reason_status} onChange={handelInput}>
			<option value="Abscond">Terminate</option>
			<option value="Abscond">Abscond</option>
			<option value="Resigned">Resigned</option>
            
        </select>
		</div>
       </div>

	<div className="col-md-12 col-sm-12 required-tooltip">
		<div className="form-group">
		<label className="form-label">Reason For Leaving </label>

		<textarea className='required-input required-tooltip'
			id="textarea"
			name="inactive_reason"
			value={users.inactive_reason} // Bind the value to state
			onChange={handelInput} // Update state on change
			placeholder=""
			rows="4" // Number of rows (optional)
			cols="68" // Number of columns (optional)
			></textarea>
									
		</div>
	</div>
   </>
   )}


	   <div className="col-md-3 col-sm-12">
			<div className="form-group">
			<label className="form-label">Experience </label>
			<input class="form-control" placeholder="" name="experience" type="text" value={users.experience} onChange={handelInput} />
		</div>
       </div>


	   <div className="col-md-3 col-sm-12 required-tooltip">
			<div className="form-group">
			<label className="form-label">Notice Period </label>

			<select className="form-control show-tick required-input required-tooltip" name="notice_period" value={users.notice_period} onChange={handelInput}>
			<option value="">Select Notice Period</option>
			<option value="1">1</option>
			<option value="15">15</option>
			<option value="30">30</option>
			<option value="60">60</option>
            
        </select>
		</div>
       </div>

	   <div className="col-md-3 col-sm-12">
			<div className="form-group">
			<label className="form-label">TDS</label>

			<select className="form-control show-tick" name="tds_applicable" value={users.tds_applicable} onChange={handelInput}>
			<option value="">Select Tds</option>
			<option value="1">Applicable</option>
			<option value="0">Not Applicable</option>
	
        </select>
		</div>
       </div>


	   <div className="col-md-3 col-sm-12">
			<div className="form-group">
			<label className="form-label">PF Status</label>

			<select className="form-control show-tick" name="pf_status" value={users.pf_status} onChange={handelInput}>
			<option value="">Select PF Status</option>
			<option value="1">Under PF</option>
			<option value="0">Not Applicable</option>
	
        </select>
		</div>
       </div>


	   <div className="col-md-3 col-sm-12">
			<div className="form-group">
			<label className="form-label">Notice Period Status</label>

			<select className="form-control show-tick" name="notice_period_status" value={users.notice_period_status} onChange={handelInput}>
			<option value="">Select Notice Period Status</option>
			<option value="1">Under Notice Period</option>
			<option value="0">Not Applicable</option>
	
        </select>
		</div>
       </div>


	   <div className="col-md-3 col-sm-12">
			<div className="form-group">
			<label className="form-label">Flat Status</label>

			<select className="form-control show-tick" name="flat_status" value={users.flat_status} onChange={handelInput}>
			<option value="">Select Flat Status</option>
			<option value="1">Under Flat</option>
			<option value="0">Not Applicable</option>
	
        </select>
		</div>
       </div>

	   <div className="col-md-3 col-sm-12">
			<div className="form-group">
			<label className="form-label">Current Salary </label>
			<input class="form-control" placeholder="" name="current_salary" type="text" value={current_salary} onChange={handelNumber} />
		</div>
       </div>


	   <div className="col-md-3 col-sm-12">
			<div className="form-group">
			<label className="form-label">Expected Salary </label>
			<input class="form-control" placeholder="" name="expected_salary" type="text" value={expected_salary} onChange={handelNumber1} />
		</div>
       </div>


	   <div className="col-md-3 col-sm-12 required-tooltip">
			<div className="form-group">
			<label className="form-label">Role </label>

			<select className="form-control show-tick required-input required-tooltip" name="user_role_id" value={users.user_role_id} onChange={handelInput}>
			<option value="">Select Role</option>
				{roleval.map(option => (
				<option key={option.role_id} value={option.role_id}>
				{option.role_name}
				</option>
				))}
        </select>
		</div>
       </div>


	    <div className="col-md-3 col-sm-12 required-tooltip">
			<div className="form-group">
			<label className="form-label">Employee Shift </label>

			<select className="form-control show-tick required-input required-tooltip" name="employee_shift" value={employee_shift} onChange={handelShiftEmployee}>
			<option value="">Select Employee Shift</option>
			<option value="1">Normal Shift</option>
            <option value="2">Nearby Shift</option>
        </select>
		</div>
       </div>


	   {employee_shift==2 && (
		
		<div className="col-md-3 col-sm-12 required-tooltip">
			 <div className="form-group">
			 <label className="form-label">Contractor </label>
 
			 <select className="form-control show-tick required-input required-tooltip" name="contractor" value={contractor} onChange={handleContractorDropdownChange} >
			 <option value="">Select Contractor</option>
				 {contractordata.map(option => (
				 <option key={option.id} value={option.id}>
				 {option.contractor_name}
				 </option>
				 ))}
		 </select>
				 
			 </div>
		 </div>
		)}



	   {employee_shift==2 && (
		<div className="col-md-3 col-sm-1 required-tooltip">   
			<div className="form-group">
			<label className="form-label">Contractor Type </label>
			<select className="form-control show-tick required-input required-tooltip"
          value={contractortype} name="contratortype"
          onChange={handleContractorTypeDropdownChange}
          disabled={contractotypeDropdownOptions.length === 0}
        >
          <option value="">Select Designation</option>
          {contractotypeDropdownOptions.map((option) => (
            <option key={option.contractor_type_id} value={option.contractor_type_id}>
              {option.role_name}
            </option>
          ))}
        </select>
			</div>
		</div>

)}

               



											</div>


											{/* <div className="row mt-3">
  <div className="col-md-12">
    <button className="btn btn-primary btn-block">Save</button>
  </div>
</div> */}

											<div className="row mt-3">
  <div className="col-md-2">
    <button className="btn btn-primary w-100">
      Save
    </button>
  </div>

  {net_take && Number(net_take) > 0 && (
  <div className="col-md-2">
    <button
      type="button"
      className="btn btn-primary w-100"
      onClick={generateOfferLetter}
    >
      Offer Letter
    </button>
  </div>
)}

{users.date_of_leaving && (
  <div className="col-md-3">
    <button
      type="button"
      className="btn btn-primary w-100"
      onClick={generateExperienceCertificate}
    >
      Experience Certificate
    </button>
  </div>
)}


</div>




											</form>

											</div>

																</div>
															</div>
														</div>
													</div>
													</div>
													</div>
													</div>

                                    </Accordion>

									<Accordion title="Manage Approval">

									<div className="container-fluid">
														<div className="row clearfix">
															<div className="col-md-12">
																<div className="card">


									 <div className="card-body">
									

										<form onSubmit={handleApprovalSubmit}>
											<div class="row">
									<div className="col-md-3 col-sm-12 required-tooltip">
											<div className="form-group">
											<label className="form-label">Incharge </label>

											<select className="form-control show-tick required-input required-tooltip" name="inchargeval" value={inchargeval} onChange={handleapprovalinchargeChange}>
											<option value="">None</option>
												{allemployeeval.map(option1 => (
												<option key={option1.user_id} value={option1.user_id}>
												{option1.first_name} {option1.last_name} {option1.employee_id}
												</option>
												))}
										</select>
										</div>
									</div>

									<div className="col-md-3 col-sm-12 required-tooltip">
											<div className="form-group">
											<label className="form-label">Hod </label>

											<select className="form-control show-tick required-input required-tooltip" name="hodval" value={hodval} onChange={handleapprovalhodChange}>
											<option value="">None</option>
												{allemployeeval.map(option => (
												<option key={option.user_id} value={option.user_id}>
												{option.first_name} {option.last_name} {option.employee_id}
												</option>
												))}
										</select>
										</div>
									</div>

									</div>

									<div class="row">

											<div className="form-footer">
												<button className="btn btn-primary btn-block">Save</button>
											</div>
											</div>

									</form>
									</div>
									</div>
									</div>
									</div>
									</div>

                                    </Accordion>


									<Accordion title="Salary Info">

									<div className="container-fluid">
														<div className="row clearfix">
															<div className="col-md-12">
																<div className="card">


									 <div className="card-body">
										{/* <form onSubmit={handleapprovalSubmit}> */}

										<form onSubmit={handleSalarySubmit}>
											<div class="row">
										<div className="col-md-4 col-sm-12 required-tooltip">
												<div className="form-group">
												<label className="form-label">Gross Salary </label>

												<input class="form-control required-input required-tooltip" placeholder="Gross Salary" name="gross_salary" type="number" value={gross_salary} readOnly={isReadonly} onChange={(e)=>{handelsalaryInput(e.target.value,convy,wash_allow,insurance,hostel_fee);setGross(e.target.value)}} />
											</div>
									    </div>


										<div className="col-md-4 col-sm-12 required-tooltip">
												<div className="form-group">
												<label className="form-label">Convyance </label>

												<input class="form-control required-input required-tooltip" placeholder="Convyance" name="convy" type="text" value={convy} readOnly={isReadonly} onChange={(e)=>{handelsalaryInput(gross_salary,e.target.value,wash_allow,insurance,hostel_fee);setConvy(e.target.value)}}  disabled={gross_salary.length === 0}/>
											</div>
									    </div>

										<div className="col-md-4 col-sm-12 required-tooltip">
												<div className="form-group">
												<label className="form-label">Wash Allowance </label>

												<input class="form-control required-input required-tooltip" placeholder="Wash Allowance" readOnly={isReadonly} name="wash_allow" type="text" value={wash_allow} onChange={(e)=>{handelsalaryInput(gross_salary,convy,e.target.value,insurance,hostel_fee);setWashAllow(e.target.value)}} disabled={gross_salary.length === 0} />
											</div>
									    </div>


										<div className="col-md-4 col-sm-12 required-tooltip">
												<div className="form-group">
												<label className="form-label">Basic Salary</label>

												<input class="form-control required-input required-tooltip" placeholder="" name="basic_salary" type="text" value={basic_salary}  onChange={handelsalaryInput} disabled/>
											</div>
									    </div>

									

										<div className="col-md-4 col-sm-12 required-tooltip">
												<div className="form-group">
												<label className="form-label">HRA</label>

												<input class="form-control required-input required-tooltip" placeholder="" name="hra" type="text" value={hra} onChange={handelsalaryInput} disabled/>
											</div>
									    </div>

										<div className="col-md-4 col-sm-12 required-tooltip">
												<div className="form-group">
												<label className="form-label">Special Conveyance</label>

												<input class="form-control required-input required-tooltip" placeholder="" name="special_convyance" type="text" value={special_convyance} onChange={handelsalaryInput} disabled/>
											</div>
									    </div>


										<div className="col-md-4 col-sm-12 required-tooltip">
												<div className="form-group">
												<label className="form-label">PF Emloyer</label>

												<input class="form-control required-input required-tooltip" placeholder="" name="pf_employer" type="text" value={pf_employer} onChange={handelsalaryInput} disabled/>
											</div>
									    </div>


										<div className="col-md-4 col-sm-12 required-tooltip">
												<div className="form-group">
												<label className="form-label">ESI Employer</label>

												<input class="form-control required-input required-tooltip" placeholder="" name="esi_employer" type="text" value={esi_employer} onChange={handelsalaryInput} disabled/>
											</div>
									    </div>

										<div className="col-md-4 col-sm-12 required-tooltip">
												<div className="form-group">
												<label className="form-label">Insurance</label>

												<input class="form-control required-input required-tooltip" placeholder="" name="insurance" type="text" readOnly={isReadonly} value={insurance} onChange={(e)=>{handelsalaryInput(gross_salary,convy,wash_allow,e.target.value,hostel_fee);setInsurance(e.target.value)}}  disabled={gross_salary.length === 0}/>
											</div>
									    </div>

										<div className="col-md-4 col-sm-12 required-tooltip">
												<div className="form-group">
												<label className="form-label">PF Emloyee</label>

												<input class="form-control required-input required-tooltip" placeholder="" name="pf_employee" type="text" value={pf_employee} onChange={handelsalaryInput} disabled/>
											</div>
									    </div>

										<div className="col-md-4 col-sm-12 required-tooltip">
												<div className="form-group">
												<label className="form-label">ESI Emloyee</label>

												<input class="form-control required-input required-tooltip" placeholder="" name="esi_employee" type="text" value={esi_employee} onChange={handelsalaryInput} disabled/>
											</div>
									    </div>

										<div className="col-md-4 col-sm-12 required-tooltip">
												<div className="form-group">
												<label className="form-label">Profession Tax</label>

												<input class="form-control required-input required-tooltip" placeholder="" name="pt" type="text" value={pt} onChange={handelsalaryInput} disabled/>
											</div>
									    </div>

										<div className="col-md-3 col-sm-12 required-tooltip">
												<div className="form-group">
												<label className="form-label">Hostel Fee</label>

												<input class="form-control required-input required-tooltip" placeholder="" name="pt" readOnly={isReadonly} type="text" value={hostel_fee} onChange={(e)=>{handelsalaryInput(gross_salary,convy,wash_allow,insurance,e.target.value);setHostelFee(e.target.value)}}  disabled={gross_salary.length === 0}/>
											</div>
									    </div>

										<div className="col-md-3 col-sm-12 required-tooltip">
												<div className="form-group">
												<label className="form-label">TDS</label>

												<input class="form-control required-input required-tooltip" placeholder="" name="tds" type="text" value={tds} onChange={handelsalaryInput} disabled/>
											</div>
									    </div>

										<div className="col-md-3 col-sm-12 required-tooltip">
												<div className="form-group">
												<label className="form-label">CTC</label>

												<input class="form-control required-input required-tooltip" placeholder="" name="ctc" type="text" value={ctc} onChange={handelsalaryInput} disabled/>
											</div>
									    </div>


										<div className="col-md-3 col-sm-12 required-tooltip">
												<div className="form-group">
												<label className="form-label">Take Home</label>

												<input class="form-control required-input required-tooltip" placeholder="" name="net_take" type="text" value={net_take} onChange={handelsalaryInput} disabled/>
											</div>
									    </div>


										<div className="col-md-3 col-sm-12">
												<div className="form-group">
												<label className="form-label">UAN No</label>

												<input class="form-control" placeholder="" name="uan_no" type="text" value={uan_no} onChange={(e)=>setUanNo(e.target.value)}/>
											</div>
									    </div>

										<div className="col-md-3 col-sm-12">
												<div className="form-group">
												<label className="form-label">Account No</label>

												<input class="form-control" placeholder="" name="account_no" type="text" value={account_no} onChange={(e)=>setAccountNo(e.target.value)}/>
											</div>
									    </div>


										<div className="col-md-3 col-sm-12">
												<div className="form-group">
												<label className="form-label">PF No</label>

												<input class="form-control" placeholder="" name="pf_no" type="text" value={pf_no} onChange={(e)=>setPfNo(e.target.value)}/>
											</div>
									    </div>

										<div className="col-md-3 col-sm-12">
												<div className="form-group">
												<label className="form-label">ESI No</label>

												<input class="form-control" placeholder="" name="esi_no" type="text" value={esi_no} onChange={(e)=>setEsiNo(e.target.value)}/>
											</div>
									    </div>

									

									</div>

									

									<div class="row">

											<div className="form-footer">

											
												<button className="btn btn-primary btn-block">Save</button>
											</div>
											</div>

									</form>
									</div>
									</div>
									</div>
									</div>
									</div>

                                    </Accordion>


									<Accordion title="Change Password">

									<div className="container-fluid">
														<div className="row clearfix">
															<div className="col-md-12">
																<div className="card">


									<div className="card-body">
										{/* <form onSubmit={handleapprovalSubmit}> */}

										<form onSubmit={handleChangePaswordSubmit}>
											<div class="row">
									<div className="col-md-3 col-sm-12 required-tooltip">
											<div className="form-group">
											<label className="form-label">Password </label>

											<input class="form-control required-input required-tooltip" placeholder="" name="newpassword" type="text" value={newpassword} onChange={handleNewPasswordChange}/>
										</div>
									</div>

									<div className="col-md-3 col-sm-12 required-tooltip">
											<div className="form-group">
											<label className="form-label">Confirm Passord </label>

											<input class="form-control required-input required-tooltip" placeholder="" name="confirmnewpassword" type="text" value={confirmnewpassword} onChange={handleConfirmNewPasswordChange}/>
										</div>
									</div>

									</div>

									<div class="row">

											<div className="form-footer">
												<button className="btn btn-primary btn-block">Save</button>
											</div>
											</div>

									</form>
									</div>
									</div>
									</div>
									</div>
									</div>

</Accordion>


										<Accordion title="Profile Picture">

										<div className="container-fluid">
															<div className="row clearfix">
																<div className="col-md-12">
																	<div className="card">


										<div className="card-body">
											

											<form onSubmit={handleProfileSubmit}>
												<div class="row">
										<div className="col-md-3 col-sm-12">
												<div className="form-group">
												<label className="form-label">Browse <span className="form-required">*</span> </label>
												
												<input type="file" accept="image/*" onChange={handleImageChange} className="block w-full" />
        
												{/* {preview && <img src={preview} alt="Preview" className="h-40 w-40 object-cover mt-2" />} */}
												
												{fetchprofile!='' && <img src={imagepath} alt="Preview" className="h-40 w-40 object-cover mt-2" />}
												
											</div>
										</div>

										

										</div>

										<div class="row">

												<div className="form-footer">
													<button className="btn btn-primary btn-block">Save</button>
												</div>
												</div>

										</form>
										</div>
										</div>
										</div>
										</div>
										</div>

										</Accordion>


										<Accordion title="Recruitment Details">

										<RecruitmentDetails />

										</Accordion>


										<Accordion title="Employee Verification">

										<EmpVerification />

										</Accordion>

										<Accordion title="Training & Accomodation">

										<TraingingAccomodation />

										</Accordion>


										


										<Accordion title="Qualification">

										<div className="container-fluid">
															<div className="row clearfix">
																<div className="col-md-12">
																	<div className="card">


										<div className="card-body">
											

											<form onSubmit={handleQualifcationSubmit}>
												<div class="row">
										
												<div className="col-md-6 col-sm-12 required-tooltip">   
												<div className="form-group"> 
												<label className="form-label">School/University </label>
													<input
														type="text"
														className="form-control required-input required-tooltip"
														placeholder="School/University" name="qualification_name" value={edu.qualification_name} onChange={handelEducationInput}
													/>
												</div>
											</div>

											<div className="col-md-6 col-sm-12 required-tooltip">
											<div className="form-group">
											<label className="form-label">Education Level </label>

											<select className="form-control show-tick required-input required-tooltip" name="educationlevel" value={edu.educationlevel} onChange={handelEducationInput}>
												<option value="">Select Education Lervel</option>
												{alleducationlevel.map(option => (
												<option key={option.education_level_id} value={option.education_level_id}>
												{option.name} 
												</option>
												))} 
										</select>
										</div>
									</div>

									<div className="col-md-6 col-sm-12 required-tooltip">
									<label className="form-label">From Year </label>
										<div className="form-group">

										<input type="date" className="form-control required-input required-tooltip" name="from_year" value={edu.from_year}
																onChange={handelEducationInput} placeholder="from" />
										</div>
									</div>

									<div className="col-md-6 col-sm-12 required-tooltip">
									
										<div className="form-group">
										<label className="form-label">To Year </label>
										<input type="date" className="form-control required-input required-tooltip" name="to_year" value={edu.to_year}
																onChange={handelEducationInput} placeholder="to" />
										</div>
									</div>

									<div className="col-md-6 col-sm-12 required-tooltip">
											<div className="form-group">
											<label className="form-label">Language </label>

											<select className="form-control show-tick required-input required-tooltip" name="language" value={edu.language} onChange={handelEducationInput}>
											<option value="">Select Language</option>
												{allqualificationlanguage.map(option => (
												<option key={option.language_id} value={option.language_id}>
												{option.language_name} 
												</option>
												))} 
										</select>
										</div>
									</div>


									<div className="col-md-6 col-sm-12">
											<div className="form-group">
											<label className="form-label">Professional Courses (if any) 
											</label>

											<select className="form-control show-tick" name="skill" value={edu.skill} onChange={handelEducationInput}>
												<option value="">Professional Courses (if any) </option>
												{allqualificationskill.map(option => (
												<option key={option.skill_id} value={option.skill_id}>
												{option.skill_name} 
												</option>
												))} 
										</select>
										</div>
									</div>


									<div className="col-md-12 col-sm-12">
										<div className="form-group">
										<label className="form-label">Description</label>

										<textarea
										id="textarea"
										name="description"
										value={edu.description} // Bind the value to state
										onChange={handelEducationInput} // Update state on change
										placeholder="Description"
										rows="4" // Number of rows (optional)
										cols="68" // Number of columns (optional)
									></textarea>
									
									</div>
								</div>


										

										</div>

										<div class="row">

												<div className="form-footer">
													<button className="btn btn-primary btn-block">Save</button>
												</div>
												</div>

										</form>
										</div>
										</div>
										</div>
										</div>
										</div>

										</Accordion>



										<Accordion title="Work Experience">


											

										<div className="container-fluid">
															<div className="row clearfix">
																<div className="col-md-12">
																	<div className="card">


										<div className="card-body">
											

											<form onSubmit={handleWorkingExpSubmit}>
												<div class="row">
										
												<div className="col-md-6 col-sm-12 required-tooltip">   
												<div className="form-group"> 
												<label className="form-label">Company Name </label>
													<input
														type="text"
														className="form-control required-input required-tooltip"
														placeholder="Company Name" name="company_name" value={work.company_name} onChange={handelWorkExpInput}
													/>
												</div>
											</div>

											<div className="col-md-6 col-sm-12 required-tooltip">   
												<div className="form-group"> 
												<label className="form-label">Post </label>
													<input
														type="text"
														className="form-control required-input required-tooltip"
														placeholder="Post" name="post" value={work.post} onChange={handelWorkExpInput}
													/>
												</div>
											</div>

											
									<div className="col-md-6 col-sm-12 required-tooltip">
									<label className="form-label">From Date </label>
										<div className="form-group">

										<input type="date" className="form-control required-input required-tooltip" name="from_date" value={work.from_date}
																onChange={handelWorkExpInput} placeholder="" />
										</div>
									</div>

									<div className="col-md-6 col-sm-12 required-tooltip">
									
										<div className="form-group">
										<label className="form-label">To Date </label>
										<input type="date" className="form-control required-input required-tooltip" name="to_date" value={work.to_date}
																onChange={handelWorkExpInput} placeholder="" />
										</div>
									</div>

									


									<div className="col-md-12 col-sm-12">
										<div className="form-group">
										<label className="form-label">Description</label>

										<textarea
										id="textarea"
										name="description"
										value={work.description} // Bind the value to state
										onChange={handelWorkExpInput} // Update state on change
										placeholder="Description"
										rows="4" // Number of rows (optional)
										cols="68" // Number of columns (optional)
									></textarea>
									
									</div>
								</div>


										

										</div>

										<div class="row">

												<div className="form-footer">
													<button className="btn btn-primary btn-block">Save</button>
												</div>
												</div>

										</form>
										</div>
										</div>
										</div>
										</div>
										</div>


												


										<div className="card-body">
											<div className="table-responsive">
												<table className="table table-hover table-striped table-vcenter text-nowrap mb-0">
													<thead>
														<tr>
															<th>Action</th>
															<th>Company Name</th>
															<th>Post</th>
															<th>From Date</th>
															<th>To Date</th>
														</tr>
													</thead>
													<tbody>



														{
															data.map((exp, index) => {

																return <tr key={index}>
																	<td className="d-flex">
																	<button
																			type="button" onClick={() =>{ handleUpdate(exp.work_experience_id);setWork(emptyWork)}}
																			className="btn btn-icon btn-sm"
																			title="Edit" data-toggle="modal"
																			data-target="#exampleEditModal"
																		>
																			<i className="fa fa-edit" />
																		</button>
																	</td>
																	<td>
																		<span>{exp.company_name}</span>
																	</td>
																	<td>
																		<span>{exp.post}</span>
																	</td>
																	<td>
																		<span>{exp.from_date}</span>
																	</td>

																	<td>
																		<span>{exp.to_date}</span>
																	</td>

																	
																</tr>


															})
														}

													</tbody>
												</table>
											</div>



											
										</div>

										</Accordion>





										<Accordion title="Document">


											

										<div className="container-fluid">
															<div className="row clearfix">
																<div className="col-md-12">
																	<div className="card">


										<div className="card-body">
											

											<form onSubmit={handleDocumentUploadSubmit}>
												<div class="row">
										
												<div className="col-md-6 col-sm-12 required-tooltip">   
												<div className="form-group"> 
												<label className="form-label">Document Type </label>
												<select className="form-control show-tick required-input required-tooltip" name="document_type" value={document.document_type} onChange={handelDocumentUploadInput}>
											<option value="">Select Document Type</option>
												{alldocumenttypelevel.map(option => (
												<option key={option.document_type_id} value={option.document_type_id}>
												{option.document_type} 
												</option>
												))} 
										</select>
												</div>
											</div>

											

											
									<div className="col-md-6 col-sm-12 required-tooltip">
									<label className="form-label">Date Of Expiry </label>
										<div className="form-group">

										<input type="date" className="form-control required-input required-tooltip" name="date_of_expiry" value={document.date_of_expiry}
																onChange={handelDocumentUploadInput} placeholder="" />
										</div>
									</div>



									<div className="col-md-6 col-sm-12 required-tooltip">   
												<div className="form-group"> 
												<label className="form-label">Document Title </label>
													<input
														type="text"
														className="form-control required-input required-tooltip"
														placeholder="Document Title" name="title" value={document.title} onChange={handelDocumentUploadInput}
													/>
												</div>
											</div>

									<div className="col-md-6 col-sm-12">
									
										<div className="form-group">
										<label className="form-label">Dcoument File </label>
										<input type="file" accept="image/*" onChange={handleDocumentChange} className="block w-full" />
										<span style={{fontSize:'10px',fontWeight:'900'}}>Upload files only: png, jpg, jpeg, gif, txt, pdf, xls, xlsx, doc, docx</span>
										</div>
									</div>

									


									<div className="col-md-12 col-sm-12">
										<div className="form-group">
										<label className="form-label">Description</label>

										<textarea
										id="textarea"
										name="description"
										value={document.description} // Bind the value to state
										onChange={handelDocumentUploadInput} // Update state on change
										placeholder="Description"
										rows="4" // Number of rows (optional)
										cols="68" // Number of columns (optional)
									></textarea>
									
									</div>
								</div>


										

										</div>

										<div class="row">

												<div className="form-footer">
													<button className="btn btn-primary btn-block">Save</button>
												</div>
												</div>

										</form>
										</div>
										</div>
										</div>
										</div>
										</div>


												


										<div className="card-body">
											<div className="table-responsive">
												<table className="table table-hover table-striped table-vcenter text-nowrap mb-0">
													<thead>
														<tr>
															<th>Action</th>
															<th>Document Type</th>
															<th>Document Title</th>
															<th>Date Of Expiry</th>
														</tr>
													</thead>
													<tbody>



														{
															docfetch.map((doc, index) => {

																let filepath=APP_BASE_URL+'/aah-api/uploads/document/'+doc.document_file;

																return <tr key={index}>
																	<td className="d-flex">
																	<a
																		href={filepath}
																		download={filepath}
																	
																		>
																		<button type="button" className="btn btn-icon btn-sm" title="Print" data-toggle="tooltip" data-placement="top"><i className="icon-printer" /></button>
																		</a>
																	<button
																			type="button" onClick={() =>{ handleDocUpdate(doc.document_id);setWork(emptyWork)}}
																			className="btn btn-icon btn-sm"
																			title="Edit" data-toggle="modal"
																			data-target="#exampleEditDocumentModal"
																		>
																			<i className="fa fa-edit" />
																		</button>
																	</td>
																	<td>
																		<span>{doc.document_type}</span>
																	</td>
																	<td>
																		<span>{doc.title}</span>
																	</td>
																	<td>
																		<span>{doc.date_of_expiry}</span>
																	</td>

																	

																	
																</tr>


															})
														}

													</tbody>
												</table>
											</div>



											
										</div>

										</Accordion>



                                        {/* <span style={{width:'100px',float: 'right',margin: '10px 35px 15px 10px'}}
										type="button"
										
										onClick={()=>setToggle(!toggle)}
									>
										<i className="fa fa-angle-down mr-2" />
										
									</span> */}
                                    
                                            




										</div>
									</div>
								</div>

							</div>
						</div>
					</div>

				</div>
			</div>



			<div
				className="modal fade"
				id="exampleEditModal"
				tabIndex={-1}
				role="dialog"
				aria-labelledby="exampleModalLabel"
				aria-hidden="true"
			>
				<form onSubmit={handleEditWorkExpSubmit}>
					<div className="modal-dialog" role="document">
						<div className="modal-content">
							<div className="modal-header">
								<h5 className="modal-title" id="exampleModalLabel">
									Edit Work Experience
								</h5>
								<button type="button" className="close" data-dismiss="modal" aria-label="Close">
									<span aria-hidden="true">×</span>
								</button>
							</div>
							<div className="modal-body">
								<div className="row clearfix">
									<div className="col-md-12 col-sm-6">
										<div className="form-group">
										<label className="form-label">Company Name</label>
											<input type="text" className="form-control" name="company_name" value={work.company_name}
												onChange={handelWorkExpInput} placeholder="Company Name" />
										</div>
									</div>
									<div className="col-md-12 col-sm-6">
										<div className="form-group">
										<label className="form-label">Post </label>
											<input type="text" className="form-control" name="post" value={work.post}
												onChange={handelWorkExpInput} placeholder="Post" />
										</div>
									</div>
									

									<div className="col-md-12 col-sm-6">
										<div className="form-group">
										<label className="form-label">From Date </label>
										<input type="date" className="form-control" name="from_date" value={work.from_date}
																onChange={handelWorkExpInput} placeholder="" />
										</div>
									</div>

									<div className="col-md-12 col-sm-6">
										<div className="form-group">
										<label className="form-label">To Date </label>
										<input type="date" className="form-control" name="to_date" value={work.to_date}
																onChange={handelWorkExpInput} placeholder="" />
										</div>
									</div>


									<div className="col-md-12 col-sm-6">
										<div className="form-group">
										<label className="form-label">Experience</label>
										<textarea
										id="textarea"
										name="description"
										value={work.description} // Bind the value to state
										onChange={handelWorkExpInput} // Update state on change
										placeholder="Description"
										rows="4" // Number of rows (optional)
										cols="45" // Number of columns (optional)
									></textarea>
										</div>
									</div>

								</div>
							</div>
							<div className="modal-footer">

							<input type="hidden" className="form-control" name="id" value={work.work_experience_id}
																 />
								<button type="button" className="btn btn-secondary" data-dismiss="modal">
									Close
								</button>
								<button type="submit" className="btn btn-primary">
									Save changes
								</button>
							</div>
						</div>
					</div>

				</form>

			</div>



			<div
				className="modal fade"
				id="exampleEditDocumentModal"
				tabIndex={-1}
				role="dialog"
				aria-labelledby="exampleModalLabel"
				aria-hidden="true"
			>
				<form onSubmit={handleEditDocumentSubmit}>
					<div className="modal-dialog" role="document">
						<div className="modal-content">
							<div className="modal-header">
								<h5 className="modal-title" id="exampleModalLabel">
									Edit Document
								</h5>
								<button type="button" className="close" data-dismiss="modal" aria-label="Close">
									<span aria-hidden="true">×</span>
								</button>
							</div>
							<div className="modal-body">
								<div className="row clearfix">
									<div className="col-md-12 col-sm-6">
										<div className="form-group">
										<label className="form-label">Document Type</label>
										<select className="form-control show-tick" name="document_type" value={document.document_type} onChange={handelDocumentUploadInput}>
											<option value="">Select Document Type</option>
												{alldocumenttypelevel.map(option => (
												<option key={option.document_type_id} value={option.document_type_id}>
												{option.document_type} 
												</option>
												))} 
										</select>
										</div>
									</div>
									<div className="col-md-12 col-sm-6">
										<div className="form-group">
										<label className="form-label">Date Of Expiry </label>
										<input type="date" className="form-control" name="date_of_expiry" value={document.date_of_expiry}
																onChange={handelDocumentUploadInput} placeholder="" />
										</div>
									</div>
									

									<div className="col-md-12 col-sm-6">
										<div className="form-group">
										<label className="form-label">Document Title</label>
										<input
														type="text"
														className="form-control"
														placeholder="Document Title" name="title" value={document.title} onChange={handelDocumentUploadInput}
													/>
										</div>
									</div>

									<div className="col-md-12 col-sm-6">
										<div className="form-group">
										<label className="form-label">Dcoument File <span className="form-required">*</span> </label>
										<input type="file" accept="image/*" onChange={handleDocumentChange} className="block w-full" /><br />
										<span style={{fontSize:'10px',fontWeight:'900'}}>Upload files only: png, jpg, jpeg, gif, txt, pdf, xls, xlsx, doc, docx</span><br />
										<a href={filepath}><span style={{fontSize:'16px',fontWeight:'900',color:'red'}}>{document.document_file}</span></a>
										
										</div>
									</div>


									<div className="col-md-12 col-sm-6">
										<div className="form-group">
										<label className="form-label">Description</label>
										<textarea
										id="textarea"
										name="description"
										value={document.description} // Bind the value to state
										onChange={handelDocumentUploadInput} // Update state on change
										placeholder="Description"
										rows="4" // Number of rows (optional)
										cols="45" // Number of columns (optional)
									></textarea>
										</div>
									</div>

								</div>
							</div>
							<div className="modal-footer">

							<input type="hidden" className="form-control" name="id" value={document.document_id}
																 />
								<button type="button" className="btn btn-secondary" data-dismiss="modal">
									Close
								</button>
								<button type="submit" className="btn btn-primary">
									Save changes
								</button>
							</div>
						</div>
					</div>

				</form>

			</div>




		</>
	);
}

const mapStateToProps = (state) => ({
	fixNavbar: state.settings.isFixNavbar,
	statisticsOpen: state.settings.isStatistics,
	statisticsClose: state.settings.isStatisticsClose,
})

const mapDispatchToProps = (dispatch) => ({
	statisticsAction: (e) => dispatch(statisticsAction(e)),
	statisticsCloseAction: (e) => dispatch(statisticsCloseAction(e))
})
export default connect(mapStateToProps, mapDispatchToProps)(EmployeeDetailControl);